import { render, staticRenderFns } from "./base-stack-item.vue?vue&type=template&id=4a61e610&scoped=true"
import script from "./base-stack-item.vue?vue&type=script&setup=true&lang=js"
export * from "./base-stack-item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-stack-item.vue?vue&type=style&index=0&id=4a61e610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a61e610",
  null
  
)

export default component.exports